import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import intervalPlural from "i18next-intervalplural-postprocessor";

export const defaultNS = "common";

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    debug: process.env.NODE_ENV === "development",
    lng: "pl",
    fallbackLng: "pl",
    ns: [],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    defaultNS,
  });

export default i18n;
